import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import DropDownFromLookupTable from "../select/SelectBoxFromLookupTable";
import lookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
import { SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import ScheduleService from "../../services/ScheduleService";
import { AxiosResponse } from "axios";
import sharedUtils from "../grid/sharedUtilities";
import UserService, { RoleGroupNames } from "../../services/UserService";

interface ClientLookUpComponentProps extends WithTranslation {
    setParentFilterValuesCallback: (venueId: string, clientId: string, isclientFound: boolean) => void;
    refreshSignal: boolean;
}

interface ClientLookUpComponentState {
    clientId: string;
    isLoad: boolean;
    isShowDropDown: boolean;
}
class ClientLookUpComponent extends React.Component<ClientLookUpComponentProps> {
    state: ClientLookUpComponentState;
    utils: sharedUtils;
    service: ScheduleService;
    lookUp: lookupService;
    constructor(props: ClientLookUpComponentProps) {
        super(props);
        this.utils = new sharedUtils();
        this.service = new ScheduleService();
        this.lookUp = new lookupService();
        this.state = {
            clientId: "",
            isLoad: true,
            isShowDropDown: false,
        };
    }

    componentDidMount() {
        this.retrieveLookup();
    }

    componentDidUpdate(prevProps: ClientLookUpComponentProps) {
        if (this.props.refreshSignal != prevProps.refreshSignal) {
            this.retrieveLookup();
        }
    }

    retrieveLookup = () => {
        this.lookUp
            .getLookupByLookupTypeIndex(LookupTypeIndexes.clientType)
            .then(this.handleClientLookUpSuccess)
            .catch(this.handleStandardError);
    };

    handleClientLookUpSuccess = (response: AxiosResponse<any>) => {
        if (response && response.data && response.data.data && response.data.data.length > 0) {
            var clients: any[] = response.data.data;
            this.setState(
                {
                    clientId: clients[0].id,
                    isLoad: false,
                },
                () => {
                    this.props.setParentFilterValuesCallback("", clients[0].id, true);
                }
            );
            this.dropDownToShow(response.data.data);
        }
    };

    handleStandardError = (response: AxiosResponse<any>) => {
        this.setState({
            isLoad: false,
        });
    };

    dropDownToShow = (providerDataSource: LookupTypeItem[]) => {
        if (
            UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager) ||
            UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ||
            UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)
        ) {
            this.setState({
                isShowDropDown: true,
            });
        }
    };

    handleChangeClientTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            clientId: dxValueChange.value,
        });
        this.props.setParentFilterValuesCallback("", dxValueChange.value, true);
    };

    isBlank(param: string) {
        return !param || /^\s*$/.test(param) || 0 === param.length;
    }

    render() {
        return (
            <div>
                <div>
                    <div className="card" hidden={!this.state.isShowDropDown}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="row">
                                        <label className="col-12 col-xl-2 mb-0 pt-1">Client</label>
                                        <div className="col-12 col-xl-10">
                                            <DropDownFromLookupTable
                                                lookupTypeIndex={LookupTypeIndexes.clientType}
                                                onValueChanged={this.handleChangeClientTypeSelect}
                                                value={this.state.clientId}
                                            />
                                            <input
                                                data-testid={LookupTypeIndexes.clientType}
                                                type="hidden"
                                                name={LookupTypeIndexes.clientType}
                                            ></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ClientLookUpComponent);
